import React from 'react';
import { useAuthContext } from '../../agenticsaas/contexts/AuthContext';
import { useOrganizationContext } from '../../agenticsaas/contexts/OrganizationContext';
import { RcmWorkQueueShell } from '@saas-foundation/shared-frontend/workqueue';
import { WORK_QUEUE_SHELL_SUBTITLE } from '@saas-foundation/shared-frontend/workqueue/rcmWorkDomain';
import TeamQueueGoals from '../TeamQueueGoals/TeamQueueGoals';

/**
 * AgenticRCM work queue — shared shell with single-org context from SaaS OrganizationProvider.
 */
export default function WorkQueue() {
  const { user } = useAuthContext();
  const { organizationId } = useOrganizationContext();
  const organizationIds = organizationId ? [String(organizationId)] : null;

  return (
    <RcmWorkQueueShell
      user={user}
      leadSubtitle={WORK_QUEUE_SHELL_SUBTITLE}
      TeamQueueGoalsComponent={TeamQueueGoals}
      organizationIds={organizationIds}
    />
  );
}
